function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.083 15.358L10.675.975a.633.633 0 00-.542-.308h-.25a.633.633 0 00-.541.308L.917 15.358a.658.658 0 000 .634l.116.191c.108.198.317.32.542.317h16.85a.609.609 0 00.542-.317l.116-.191a.658.658 0 000-.634zm-8.25-2.608c0 .23-.186.417-.416.417h-.834a.417.417 0 01-.416-.417v-.833c0-.23.186-.417.416-.417h.834c.23 0 .416.187.416.417v.833zm-.391-2.917a.208.208 0 00.208-.183l.333-2.683a.417.417 0 00-.416-.467H9.433a.417.417 0 00-.416.467L9.35 9.65a.208.208 0 00.208.183h.884z"
});

var SvgWarning = function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "#FF6B6B"
  }, props), _ref);
};

export default SvgWarning;